module.exports = __webpack_public_path__ + "static/media/translations.1029.b546a561.resx";